import { render, staticRenderFns } from "./TranslationPopup.vue?vue&type=template&id=389f6104"
import script from "./TranslationPopup.vue?vue&type=script&lang=js"
export * from "./TranslationPopup.vue?vue&type=script&lang=js"
import style0 from "./TranslationPopup.vue?vue&type=style&index=0&id=389f6104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports